import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'

import { PageIdWoofzLove } from './pages'

type TIdToPageMapWoofzLove = Record<PageIdWoofzLove, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_LOVE: TIdToPageMapWoofzLove = {
  [PageIdWoofzLove.DOG_SEX_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/DogSexQuestion').then(
        (m) => ({
          default: m.DogSexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/DogSexQuestion'),
  },
  [PageIdWoofzLove.DOG_AGE_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.DogAgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/DogAgeQuestion'),
  },
  [PageIdWoofzLove.URGE_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_love/pages/urge/UrgePage'),
  },
  [PageIdWoofzLove.FEELINGS_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/FeelingsQuestion').then(
        (m) => ({
          default: m.FeelingsQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/FeelingsQuestion'),
  },
  [PageIdWoofzLove.URGE_1_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/urge/UrgePageVariant1').then(
        (m) => ({
          default: m.UrgePageVariant1,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/urge/UrgePageVariant1'),
  },
  [PageIdWoofzLove.TALKING_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/TalkingQuestion').then(
        (m) => ({
          default: m.TalkingQustion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/TalkingQuestion'),
  },
  [PageIdWoofzLove.DOG_FOLLOW_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/DogFollowQuestion').then(
        (m) => ({
          default: m.DogFollowQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/DogFollowQuestion'),
  },
  [PageIdWoofzLove.LICKING_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/LickingQuestion').then(
        (m) => ({
          default: m.LickingQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/LickingQuestion'),
  },
  [PageIdWoofzLove.URGE_2_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/urge/UrgePageVariant2'),
  },
  [PageIdWoofzLove.BEHAVIOR_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/BehaviorQuestion').then(
        (m) => ({
          default: m.BehaviorQustion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/BehaviorQuestion'),
  },
  [PageIdWoofzLove.FEEL_GUILTY_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love/pages/questions/FeelGuiltyQuestion'
      ).then((m) => ({
        default: m.FeelGuiltyQustion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/FeelGuiltyQuestion'),
  },
  [PageIdWoofzLove.URGE_3_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/urge/UrgePageVariant3'),
  },
  [PageIdWoofzLove.DOG_REACT_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love/pages/questions/DogReactionQuestion'
      ).then((m) => ({
        default: m.DogReactionQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/DogReactionQuestion'),
  },
  [PageIdWoofzLove.SATISFIED_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/SatisfiedQuestion').then(
        (m) => ({
          default: m.SatisfiedQustion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/SatisfiedQuestion'),
  },
  [PageIdWoofzLove.BEHAVIOR_ISSUES_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love/pages/questions/BehaviorIssuesQuestion'
      ).then((m) => ({
        default: m.BehaviorIssuesQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/BehaviorIssuesQuestion'),
  },
  [PageIdWoofzLove.YOUR_REACTION_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love/pages/questions/YourReactionQuestion'
      ).then((m) => ({
        default: m.YourReactionQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/YourReactionQuestion'),
  },
  [PageIdWoofzLove.URGE_4_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/urge/UrgePageVariant4'),
  },
  [PageIdWoofzLove.COMMANDS_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/DogCommands').then(
        (m) => ({
          default: m.DogCommands,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/DogCommands'),
  },
  [PageIdWoofzLove.DOG_BREED_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/DogBreedQuestion').then(
        (m) => ({
          default: m.DogBreedQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/DogBreedQuestion'),
  },
  [PageIdWoofzLove.DOG_NAME_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/DogNameQuestion').then(
        (m) => ({
          default: m.DogNameQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/DogNameQuestion'),
  },
  [PageIdWoofzLove.LOVE_LOAD_SCREEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/prepareFlow/LoaderScreen').then(
        (m) => ({
          default: m.LoaderScreen,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/prepareFlow/LoaderScreen'),
  },
  [PageIdWoofzLove.DOG_PROFILE_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/statistics/DogStatistics').then(
        (m) => ({
          default: m.DogStatistics,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/statistics/DogStatistics'),
  },
  [PageIdWoofzLove.MOTIVATION_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love/pages/questions/MotivationQuestion'
      ).then((m) => ({
        default: m.MotivationQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/MotivationQuestion'),
  },
  [PageIdWoofzLove.FEEL_DOG_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/FeelDogQuestion').then(
        (m) => ({
          default: m.FeelDogQustion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/FeelDogQuestion'),
  },
  [PageIdWoofzLove.FREQUENCY_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/FrequencyQuestion').then(
        (m) => ({
          default: m.FrequencyQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/FrequencyQuestion'),
  },
  [PageIdWoofzLove.PREPARE_FLOW_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdWoofzLove.EMAIL_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/email/EmailPage').then((m) => ({
        default: m.EmailPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_love/pages/email/EmailPage'),
  },
  [PageIdWoofzLove.NEWSLETTER_URGE_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzLove.PERSONALIZED_PLAN_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/urge/PersonalizedPlan').then(
        (m) => ({
          default: m.PersonalizedPlan,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/urge/PersonalizedPlan'),
  },
  [PageIdWoofzLove.LAST_CHANCE_OFFER_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love/pages/last-chance-offer/LastChanceOfferPage'
      ).then((m) => ({
        default: m.LastChanceOfferPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_love/pages/last-chance-offer/LastChanceOfferPage'
      ),
  },
  [PageIdWoofzLove.SUBSCRIPTIONS_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love/pages/subscriptions/SubscriptionsPage'
      ).then((m) => ({
        default: m.SubscriptionsPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/subscriptions/SubscriptionsPage'),
  },
  [PageIdWoofzLove.LAST_CHANCE_OFFER_2_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/questions/DogSexQuestion').then(
        (m) => ({
          default: m.DogSexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/questions/DogSexQuestion'),
  },
  [PageIdWoofzLove.CANCEL_OFFER_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love/pages/subscriptions/CancelOfferPage'
      ).then((m) => ({
        default: m.CancelOfferPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/subscriptions/CancelOfferPage'),
  },
  [PageIdWoofzLove.CHAT_UPSELL_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzLove.UPSELL_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_love/pages/upsell/Upsell'),
  },
  [PageIdWoofzLove.UPSELL_FEEDING_GUIDE_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzLove.UPSELL_EMOTIONAL_SUPPORT_LOVE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_love/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzLove.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdWoofzLove.DOWNLOAD_LOVE]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_love/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_love/pages/download-app/DownloadApp'),
  },
}
